// Stripe integration — creates a Checkout Session via Supabase Edge Function
// and redirects the user to Stripe's hosted payment page.

export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

export async function createCheckoutSession({ tile, priceInCents, successUrl, cancelUrl }) {
  const response = await fetch(
    `https://amdqkozrlsmkqkrgboue.supabase.co/functions/v1/create-checkout`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFtZHFrb3pybHNta3Frcmdib3VlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc0MzQ5MTMsImV4cCI6MjEwMzAxMDkxM30.Evj1u1zElAhaET8SAL4bGCF4iqweZCP3DwJbv42w9Nc`,
      },
      body: JSON.stringify({ tile, priceInCents, successUrl, cancelUrl }),
    }
  );

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create checkout session');
  }

  const { url, sessionId } = await response.json();
  return { url, sessionId };
}